import { Skeleton } from '@mui/material';
import './ModuleContents.scss';
import { ModuleCTA } from 'components/ModuleCTA/ModuleCTA';
import { TableOfContents } from 'pages/TableOfContents/TableOfContents';
import { ModuleTableOfContents } from 'types/learningHub/moduleContents';

type ModuleContentsProps = {
  contents: ModuleTableOfContents | undefined;
  isModuleCompleted: boolean;
  isModuleStarted: boolean;
  slug: string;
  isPending: boolean;
};

export const ModuleContents = ({ contents, isModuleCompleted, isModuleStarted, slug, isPending }: ModuleContentsProps) => {
  return (
    <div className='module-contents'>
      {!isPending && contents ? (
        <>
          <ModuleCTA isModuleCompleted={isModuleCompleted} isModuleStarted={isModuleStarted} slug={slug}></ModuleCTA>
          <TableOfContents  contents={contents} isInteractive={false} handleEntrySelection={() => {}}></TableOfContents>
        </>
      ) : (
        <Skeleton width='100%' sx={{ height: 770 }} variant='rounded' />
      )}
    </div>
  );
};
